import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/** 404-Seite: bewusst sichtbarer Hinweis statt stiller Weiterleitung auf „/". */
export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-6 px-6 py-20 text-center">
      <p className="text-6xl font-bold tracking-tight text-slate-300 dark:text-slate-600">404</p>
      <div className="space-y-2">
        <h1 className="text-2xl font-bold tracking-tight">{t('notFound.title')}</h1>
        <p className="text-sm text-slate-600 dark:text-slate-300">{t('notFound.hint')}</p>
      </div>
      <Link
        to="/"
        className="inline-flex items-center justify-center gap-2 rounded-md bg-slate-900 px-3.5 py-2 text-sm font-medium text-white transition-colors hover:bg-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:bg-white dark:text-slate-900 dark:hover:bg-slate-200 dark:focus-visible:ring-offset-slate-900"
      >
        {t('notFound.backHome')}
      </Link>
    </div>
  );
}
